<template>
  <ValidationErrors :show="showErrors"/>
  <Head :title="quote.name + ' - ' + project.title"/>
  <div class="w-full mb-6">
    <ProjectHeader :project="project">
      <template v-slot:actions>
        <Link :href="route('frontend.project.quote.index', project.id)"
              class="inline-flex items-center h-10 px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs uppercase text-black bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200">
          <ArrowCircleLeftIcon class="-ml-0.5 mr-2 h-4 w-4"></ArrowCircleLeftIcon>
          Back to Quotes
        </Link>
      </template>
    </ProjectHeader>
    <div class="space-y-6 lg:col-span-9">
      <section aria-labelledby="payment-details-heading">
        <form @submit.prevent="submit">
          <div class="shadow sm:rounded-md sm:overflow-hidden">
            <div class="bg-white px-4 p-6 space-y-6">
              <div class="pb-5 border-b border-gray-200 flex justify-between items-center">
                <div class="flex grid grid-cols-2 items-center">
                  <div>
                    <div class="flex items-end">
                      <h3
                          class="flex text-lg leading-6 font-bold text-gray-900 mr-3">
                        {{ quote.name }}
                      </h3>
                      <span class="text-sm font-medium">{{ quote.client.name }}</span>

                      <div class="ml-3 flex-col">
                        <span v-if="quote.status === 'Request'"
                              class="w-auto inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-500 text-white"> {{
                            quote.status
                          }} </span>
                        <span v-if="quote.status === 'Confirmed'"
                              class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-100 text-green-800"> {{
                            quote.status
                          }} </span>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="flex text-right items-end">
                  <div v-if="!quote.client.cmid" class="mr-3 text-sm text-yellow-700 self-center">
                    This client is missing a CMID. Please add a CMID to create an invoice.
                  </div>
                  <Button @click="create"
                          :disabled="!quote.client.cmid"
                          class="shadow-md inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed">
                    <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                         fill="none"
                         viewBox="0 0 24 24"
                         stroke="currentColor" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    Create New Invoice
                  </Button>
                </div>
              </div>
              <QuoteTabs />
              <h2>Deposit Progression</h2>
              <div class="grid grid-cols-12 gap-4">
                  <div class="col-span-3">
                    <table class="min-w-full divide-y divide-gray-200 w-full">
                                <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Amount
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Due Date
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(deposit,index) in quote.deposits" :key="index" :class="{'bg-gray-50': index%2, 'bg-white': !(index%2)}">
                                        <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                            {{deposit.amount}}%
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {{moment(deposit.due_at, 'YYYY-MM-DD').format('DD/MM/YYYY')}}
                                        </td>
                                    </tr>
                                <!-- More people... -->
                                </tbody>
                            </table>

                  </div>
              </div>
              <h2>Invoices</h2>
              <InvoiceList :invoices="invoices" :project="project" key="quote-invoices" />
            </div>
          </div>
        </form>
      </section>
    </div>
  </div>
  <CreateInvoice ref="slideout" />
    <LinkInvoiceToSupplierInvoice/>
</template>


<script>
import Authenticated from "@/Layouts/Authenticated.vue";
import {Link, Head, usePage, useForm} from "@inertiajs/vue3";
import {
  ClipboardCopyIcon,
  PlusSmIcon,
  UsersIcon,
  InformationCircleIcon,
  ChevronDownIcon,
  CogIcon,
  PencilIcon,
  CheckCircleIcon,
  ArrowCircleLeftIcon,
  FolderAddIcon,
  FolderIcon,
  DocumentAddIcon,
  DocumentDownloadIcon
} from "@heroicons/vue/outline"
import ValidationErrors from "@/Components/ValidationErrors";
import ProjectHeader from "@/Components/ProjectHeader";
import QuoteTabs from "@/Components/QuoteTabs";
import CreateInvoice from "@/Components/SlideOuts/CreateInvoice";
import Button from "@/Components/Button.vue";
import InvoiceList from "@/Components/InvoiceList.vue";
import LinkInvoiceToSupplierInvoice from "@/Components/SlideOuts/LinkInvoiceToSupplierInvoice";
import moment from "moment";

export default {
  layout: Authenticated,
  components: {
      LinkInvoiceToSupplierInvoice,
    Button,
    QuoteTabs,
    ProjectHeader,
    ValidationErrors,
    Link,
    Head,
    PlusSmIcon,
    UsersIcon,
    InformationCircleIcon,
    ChevronDownIcon,
    CogIcon,
    PencilIcon,
    ClipboardCopyIcon,
    CheckCircleIcon,
    ArrowCircleLeftIcon,
    FolderAddIcon,
    FolderIcon,
    DocumentAddIcon,
    DocumentDownloadIcon,
    CreateInvoice,
    InvoiceList
  },
  props: {
    project: Object,
    quote: Object,
    invoices: Object
  },
  created() {
        this.moment = moment
    },
  methods: {
    create() {
      // this.$refs.slideout.updating = false;
      // this.$refs.slideout.client_id = this.project.client.id;
      this.$refs.slideout.open();
    },
    // edit(quote) {
    //   this.$refs.slideout.updating = true;
    //   this.$refs.slideout.form.id = quote.id;
    //   this.$refs.slideout.form.name = quote.name;
    //   this.$refs.slideout.form.client = quote.client.name;
    //   this.$refs.slideout.form.client_id = quote.client_id;
    //   this.$refs.slideout.form.status = quote.status;
    //   this.$refs.slideout.form.project_id = quote.project_id;
    //   this.$refs.slideout.open();
    // }
  }
}
</script>
